import { useAuthStore } from "@/stores";
import { routerLogger } from "@/utils/consoleLoggers";
export function requireCoach(to, from, next) {
  const authStore = useAuthStore();
  if (authStore.isTrainer) {
    routerLogger("Is Coach, moving on.");
    next();
  } else {
    routerLogger("Not a Coach, redirecting to default page.");
    next({ name: 'Dashboard' }); // Redirect to a default page if not a coach
  }
}
